import { memo } from "react";
import Svg, { Path, type SvgProps } from "react-native-svg";

const SvgPlayFilled = (props: SvgProps) => (
  <Svg fill="none" height={24} width={25} {...props}>
    <Path
      clipRule="evenodd"
      d="M12.019 24c6.627 0 12-5.373 12-12s-5.373-12-12-12c-6.628 0-12 5.373-12 12s5.372 12 12 12m5.53-10.874a1.3 1.3 0 0 0 0-2.252l-7.32-4.227a1.3 1.3 0 0 0-1.95 1.125v8.455a1.3 1.3 0 0 0 1.95 1.126z"
      fill={props.color}
      fillRule="evenodd"
    />
  </Svg>
);
const Memo = memo(SvgPlayFilled);
export default Memo;
